var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('app-toolbar'),_c('v-slide-x-reverse-transition',{attrs:{"hide-on-leave":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }